<template>
  <div>
    <div class="row header-data-search">
      <div class="col-12 col-md-4">
        <Breadcrumb :title="'Proyectos'" :listItem="breadcrumbListItem" />
      </div>
      <div class="col-12 col-md-8">
        <div class="filter-box">
          <div
            class="input-search justify-content-md-end"
            v-if="listItem && listItem.length"
          >
            <span class="mr-3 text-nowrap">Filtrar por:</span>
            <input
              type="text"
              class="form-control form-control-sm search"
              v-model="filterText"
              placeholder="Digite para buscar"
            />
            <span class="fas-addon fa fa-search"></span>
          </div>
          <button
            class="btn btn-info"
            @click="onNew"
            v-if="rule && rule.canCreate"
          >
            <i class="fas fa-plus"></i>
            <span class="d-none d-sm-block ml-2">Nuevo</span>
          </button>
        </div>
      </div>
    </div>

    <PageLoading v-if="loading" />
    <div v-else-if="filterListItem && filterListItem.length && !loading">
      <ul class="list-group">
        <ProjectItem
          v-for="(item, index) in paginador(filterListItem)"
          :key="index"
          :item="item"
          :rule="rule"
          @onEdit="onEdit($event)"
          @onDelete="onDelete($event)"
        />
      </ul>

      <b-pagination
        v-model="currentPage"
        :total-rows="filterListItem.length"
        :per-page="perPage"
        class="my-0 mt-3"
        size="sm"
        align="right"
        v-if="totalRows > perPage"
      >
        <span class="text-info" slot="first-text">First</span>
        <span class="text-info" slot="prev-text">Prev</span>
        <span class="text-info" slot="next-text">Next</span>
        <span class="text-info" slot="last-text">Last</span>
        <span slot="page" slot-scope="{ page, active }">
          <b v-if="active">{{ page }}</b>
          <i v-else>{{ page }}</i>
        </span>
      </b-pagination>
    </div>

    <div v-else type="alert" class="alert alert-warning">{{ noDataFound }}</div>

    <b-modal
      ref="modalProject"
      hide-footer
      id="modalProject"
      no-close-on-backdrop
      :title="modalTitle"
    >
      <ProjectForm :item="Object.assign({}, item)" @onCompleted="onCompleted" />
    </b-modal>
  </div>
</template>

<script>
import ProjectItem from "@/pages/components/project/ProjectItem.vue";
import ProjectForm from "@/pages/components/project/ProjectForm.vue";
import Breadcrumb from "@/pages/components/Breadcrumb.vue";
import API from "@/services/Api";
import Global from "@/services/Global";
import BaseComponent from "@/pages/components/BaseComponent";
import PageLoading from "@/pages/components/PageLoading.vue";
export default {
  extends: BaseComponent,
  components: {
    ProjectItem,
    ProjectForm,
    PageLoading,
    Breadcrumb,
  },
  data() {
    return {
      loading: false,
      listItem: [],
      item: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      filterText: null,
      modalTitle: "Registro",
      rule: null,
      breadcrumbListItem: [
        {
          title: "Configuraciones",
          route: "settings",
        },
      ],
    };
  },
  mounted() {
    this.fetchList();
    this.fetchList2();
    this.totalRows = this.listItem.length;
  },
  computed: {
    noDataFound() {
      return Global.noDataFound;
    },
    filterListItem() {
      return this.listItem.filter((item) => {
        return (
          !this.filterText ||
          item.name.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
        );
      });
    },
  },
  methods: {
    fetchList() {
      this.loading = true;
      API.get("Project/GetAllAsync")
        .then((response) => {
          this.loading = false;
          console.log("Project", response.data);
          this.listItem =
            response && response.data && response.data.result
              ? response.data.result
              : [];
          this.totalRows = this.listItem.length;
        })
        .catch((error) => {
          this.loading = false;
          console.log("error", error);
        });
    },
    fetchList2() {
      this.loading = true;
      API.get("Company/GetAllAsync")
        .then((response) => {
          this.loading = false;
          console.log("Company", response.data);
          //console.log("Company2", JSON.parse(response.data.result.toString()));
        })
        .catch((error) => {
          this.loading = false;
          console.log("error", error);
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onNew() {
      this.item = {
        companyId: null,
      };
      this.modalTitle = "Nuevo registro";
      this.$refs["modalProject"].show();
    },
    onEdit(item) {
      this.item = item;
      this.modalTitle = "Editar registro";
      this.$refs["modalProject"].show();
    },
    onCompleted(evt) {
      this.item = {};
      if (evt) {
        this.fetchList();
      }
      this.$refs["modalProject"].hide();
    },
    onDelete(item) {
      this.axiosDelete({
        url: "Project/DeleteAsync",
        id: item.id,
      }).then(() => {
        this.currentPage = 1;
        this.onCompleted(true);
      });
    },
    paginador(items) {
      const indiceInicio = (this.currentPage - 1) * this.perPage;
      const indiceFinal =
        indiceInicio + this.perPage > items.length
          ? items.length
          : indiceInicio + this.perPage;
      return items.slice(indiceInicio, indiceFinal);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const menus = vm.$store.state.menus;
      vm.rule = menus.find((x) => x.pathName == to.name);
    });
  },
};
</script>
